import { displayNewAppointmentForm } from './displayNewAppointmentForm';
import displayNewMessageForm from './displayNewMessageForm';
import displayReplyForm from './displayReplyFormAdapter';
import {
    addCategoriesMailbox,
    removeCategoriesMailbox,
    getCategoriesMailbox,
    getCategoriesItem,
    addCategoriesItemRead,
    removeCategoriesItemRead,
} from '../common/categoriesAdapter';
import checkItemId from '../common/checkItemIdAdapter';
import { displayAppointmentForm } from '../common/displayAppointmentFormAdapter';
import displayMessageForm from '../common/displayMessageFormAdapter';
import { getRecurrence, getSeriesIdRead } from '../common/recurrenceAdapter';
import { isRemoteItem, isSharedItem } from '../common/sharedItemAdapter';
import { getSharedProperties } from '../common/sharedPropertiesAdapter';
import { closeTaskPane, openTaskPane } from './readTaskPaneUtils';
import { getReadHostItemIndex, AppointmentReadAdapter } from 'owa-addins-core';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import type { ReadingPaneState } from 'owa-calendar-reading-pane-store/lib/store/schema/ReadingPaneState';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    addNotificationMessage,
    removeNotificationMessage,
    getNotificationMessageIds,
} from '../notifications/notificationsAdapter';
import { getEnhancedLocations } from '../common/getEnhancedLocationsAdapter';
import { getAttachmentContent } from '../read/readAttachmentAdapter';
import { wrapItemWithEwsIdGetter } from 'owa-addins-ews-id-wrapper';
import type Item from 'owa-service/lib/contract/Item';
import { isFeatureEnabled } from 'owa-feature-flags';

let getItemId = (eventId: string) => async () => {
    return eventId;
};

let isAddinPinned = (addinId: string): boolean => {
    return false;
};

export default function createAppointmentReadAdapter(
    event: CalendarEvent,
    viewState: ReadingPaneState
): AppointmentReadAdapter {
    const eventId = event.ItemId.Id;
    return {
        // Here we have to cast these CalendarEvents to Items,
        // because the local CalendarEvent type is not assignable
        // to the Item type from owa-service. This means that the
        // MessageReadAdapter contract as written incorrectly describes
        // the state of the code as written.
        getItem: isFeatureEnabled('fwk-immutable-ids')
            ? wrapItemWithEwsIdGetter(event as Item & typeof event)
            : () => Promise.resolve(event as Item & typeof event),
        getItemWithUnsafeIdsImmediate: () => event as Item & typeof event,
        getItemId: getItemId(eventId),
        mode: ExtensibilityModeEnum.AppointmentAttendee,
        displayReplyForm: displayReplyForm(event),
        isAddinPinned,
        addNotificationMessage: addNotificationMessage(
            getReadHostItemIndex(eventId),
            viewState,
            eventId
        ),
        removeNotificationMessage: removeNotificationMessage(viewState, eventId),
        getNotificationMessageIds: getNotificationMessageIds(viewState),
        displayNewMessageForm: displayNewMessageForm,
        checkItemId,
        displayMessageForm,
        openTaskPane: openTaskPane(ExtensibilityModeEnum.AppointmentAttendee),
        closeTaskPane: closeTaskPane(ExtensibilityModeEnum.AppointmentAttendee),
        displayNewAppointmentForm: displayNewAppointmentForm(event),
        displayAppointmentForm: displayAppointmentForm,
        isSharedItem: isSharedItem(event),
        isRemoteItem: isRemoteItem(event),
        getRecurrence: getRecurrence(event),
        getSeriesId: getSeriesIdRead(event),
        getSharedProperties: getSharedProperties(event),
        getEnhancedLocations: getEnhancedLocations(event),
        getAttachmentContent: getAttachmentContent(viewState),
        getCategoriesMailbox: getCategoriesMailbox(event),
        addCategoriesMailbox: addCategoriesMailbox,
        removeCategoriesMailbox: removeCategoriesMailbox,
        getCategoriesItem: getCategoriesItem(event),
        addCategoriesItemRead: addCategoriesItemRead(event),
        removeCategoriesItemRead: removeCategoriesItemRead(event),
    };
}
